<div>
    <hvl-form-item class="col-12 p-fluid" label="{{ 'feeType.queryName' | translate }}">
        <input type="text" name="queryName" id="queryName" [(ngModel)]=queryName pInputText />
    </hvl-form-item>

    <div class="button-div">
        <p-toolbar *ngIf="!editDialogControl" class="flex justify-content-end"
                   styleClass="pr-0 pl-0 pt-0">
            <div>
                <button [id]="pageCode + '_cancel'" pButton label="{{ 'button.cancel' | translate }}"
                        class="w-auto p-button-text ml-2" (click)="onClose()"></button>

                <button [id]="pageCode + '_save'" pButton label="{{ 'button.save' | translate }}"
                        class="mr-2 w-auto" (click)="onClickSave(false)"></button>
            </div>
        </p-toolbar>
        <p-toolbar *ngIf="editDialogControl" class="flex justify-content-end"
                   styleClass="pr-0 pl-0 pt-0">
            <div>
                <button pButton label="{{ 'feeType.update' | translate }}"
                         class="mr-2 w-auto"
                        (click)="onClickUpdate()">
                </button>
                <button  pButton
                        label="{{ 'button.delete' | translate }}" (click)="onClickDelete()"
                        class="mr-2 w-auto p-button-outlined">
                </button>
                <button  pButton
                         label="{{ 'feeType.saveAs' | translate }}" (click)="onClickSave(true)"
                         class="mr-2 w-auto">
                </button>
            </div>
        </p-toolbar>
    </div>


</div>
